import { BaseModel } from './base';

export class ExpectedAttendee extends BaseModel {
  expectedAttendeeId: string;
  expectedAttendeeName: string;
  SubscriberId: string;
  SiteId: string;
  Status: string;
  id: string;
}